import { render, staticRenderFns } from "./WorkspaceSimpleCard.vue?vue&type=template&id=d0504820&scoped=true&lang=pug"
import script from "./WorkspaceSimpleCard.vue?vue&type=script&lang=js"
export * from "./WorkspaceSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceSimpleCard.vue?vue&type=style&index=0&id=d0504820&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0504820",
  null
  
)

export default component.exports